<div class="topbar">
  <app-menu></app-menu>
</div>
<main>
  <router-outlet />
</main>


